import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";

import { Grid, Button, Typography, Box } from "@material-ui/core";

import {
  InputMask,
  InputText,
  Modal,
  MultipleImageUploader,
} from "src/components";
import {
  atualizarImagemProduto,
  removerImagemProduto,
  salvarProduto,
  uploadImagemProduto,
} from "src/store/actions/produtos";
import * as types from "src/store/types/produtos";

function EditarProduto({ modal, changed, modals }) {
  const [imagesToUpload, setImagesToUpload] = useState([]);
  const {empresa_atual} = useSelector( state => state.usuario)

  const { produto, categoria_lista, imagens_produto } = useSelector(
    (state) => state.produtos
  );
  const dispatch = useDispatch();

  const salvar = () => {
    if (!produto.categoria_id > 0)
      changed({ categoria_id: categoria_lista[0].id });

    salvarProduto().then(
      async (id) => {
        if (id > 0) {
          dispatch({ type: types.LOADING_DELIV_PRODUTO, payload: true });
          for (let item of imagesToUpload) {
            if (item.delete) {
              await removerImagemProduto(item.id);
            } else if (item.update) {
              await atualizarImagemProduto(item.id, item.image);
            } else {
              await uploadImagemProduto(id, item.image);
            }
          }

          dispatch(
            { type: types.SET_IMAGENS_PRODUTO, payload: [] },
            {
              type: types.SET_DELIV_PRODUTO,
              payload: { titulo: "", descricao: "", icone: "" },
            },
            { type: types.LOADING_DELIV_PRODUTO, payload: false }
          );
          setImagesToUpload([]);
        }
        modals({ ...modals, editar: false });
      },
      (e) => console.log(e)
    );
  };

  return (
    <Modal open={modal.editar}>
      <Typography> Cadastro de produto </Typography>
      <Grid style={{ maxWidth: "900px" }} container spacing={1}>
        <Grid
          container
          item
          spacing={1}
          sm={produto.galeria_imagens == 1 ? 8 : 12}
        >
          <Grid item sm={12}>
            <InputText
              label="Titulo"
              value={produto.titulo}
              onChange={(event) => changed({ titulo: event.target.value })}
            />
          </Grid>
          <Grid item sm={3}>
            <InputMask
              type="cash"
              decimalScale={2}
              label="R$ Atual"
              value={produto.valor_atual}
              onChange={(event) =>
                changed({ valor_atual: event.target.values.floatValue })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputMask
              type="cash"
              decimalScale={2}
              label="R$ Anterior"
              value={produto.valor_anterior}
              onChange={(event) =>
                changed({ valor_anterior: event.target.values.floatValue })
              }
            />
          </Grid>
          <Grid item sm={2}>
            <InputText
              disabled={empresa_atual.tipo_cashback == 'F' ? true : false}
              label="Cashback(%)"
              value={produto.percentual_cashback}
              onChange={(event) =>
                changed({ percentual_cashback: event.target.value })
              }
            />
          </Grid>
          <Grid item sm={2}>
            <InputText
              select
              label="Status"
              value={produto.status}
              onChange={(event) => changed({ status: event.target.value })}
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              <option value="A"> Ativo </option>
              <option value="I"> Inativo </option>
            </InputText>
          </Grid>
          <Grid item sm={2}>
            <InputText
              select
              label="Destaque"
              value={produto.destaque}
              onChange={(event) => changed({ destaque: event.target.value })}
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              <option value={0}> Não </option>
              <option value={1}> Sim </option>
            </InputText>
          </Grid>
          <Grid item sm={2}>
            <InputText
              select
              label="Imagem"
              value={produto.galeria_imagens}
              onChange={(event) => {
                setImagesToUpload([]);
                changed({ galeria_imagens: event.target.value });
              }}
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              <option value={0}> Não </option>
              <option value={1}> Sim </option>
            </InputText>
          </Grid>
          <Grid item sm={10}>
            <InputText
              select
              label="Categoria"
              value={produto.categoria_id}
              onChange={(event) =>
                changed({ categoria_id: event.target.value })
              }
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              {categoria_lista.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.titulo}
                </option>
              ))}
            </InputText>
          </Grid>
          <Grid container spacing={2} item sm={12}>
            <Grid item sm={9}>
              <fieldset
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 0",
                  border: 0,
                }}
              >
                <legend
                  style={{
                    color: "#3e3e3e",
                    fontSize: "1rem",
                  }}
                >
                  Complementos ou Variações:
                </legend>
                <Grid item sm={3} style={{ marginRight: 5 }}>
                  <InputText
                    select
                    label="Possui"
                    value={produto.possui_complemento}
                    onChange={(event) =>
                      changed({ possui_complemento: event.target.value })
                    }
                    margin="dense"
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <option value={0}> Não </option>
                    <option value={1}> Sim </option>
                  </InputText>
                </Grid>
                <Grid item sm={3} style={{ marginRight: 5 }}>
                  <InputMask
                    disabled={produto.possui_complemento === "1" ? false : true}
                    type="number"
                    decimalScale={0}
                    label="Qtd Max."
                    value={produto.qtde_complemento}
                    onChange={(event) =>
                      changed({ qtde_complemento: event.target.value })
                    }
                  />
                </Grid>
                <Grid item sm={3} style={{ marginRight: 5 }}>
                  <InputMask
                    disabled={produto.possui_complemento === "1" ? false : true}
                    type="number"
                    decimalScale={0}
                    label="Qtd Min."
                    value={produto.qtde_complemento_min}
                    onChange={(event) =>
                      changed({ qtde_complemento_min: event.target.value })
                    }
                  />
                </Grid>
                <Grid item sm={3}>
                  <InputMask
                    disabled={produto.possui_complemento === "1" ? false : true}
                    type="number"
                    decimalScale={0}
                    label="Qtd Free"
                    value={produto.qtde_complemento_free}
                    onChange={(event) =>
                      changed({ qtde_complemento_free: event.target.value })
                    }
                  />
                </Grid>
              </fieldset>
            </Grid>
            <Grid item sm={3}>
              <fieldset
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 0",
                  border: 0,
                }}
              >
                <legend
                  style={{
                    color: "#3e3e3e",
                    fontSize: "1rem",
                  }}
                >
                  Controla estoque:
                </legend>
                <Grid item sm={12}>
                  <InputText
                    select
                    label="Estoque"
                    value={produto.controlar_estoque}
                    onChange={(event) =>
                      changed({ controlar_estoque: event.target.value })
                    }
                    margin="dense"
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <option value={0}> Não </option>
                    <option value={1}> Sim </option>
                  </InputText>
                </Grid>
              </fieldset>
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <InputText
              label="Descrição"
              multiline
              rows={3}
              maxLength={255}
              value={produto.descricao}
              onChange={(event) => changed({ descricao: event.target.value })}
            />
          </Grid>
        </Grid>
        {produto.galeria_imagens == 1 && (
          <Grid item sm={4}>
            {modal.editar && (
              <MultipleImageUploader
                templateUrl={`https://images-conexo.us-east-1.linodeobjects.com/produtos/imagens/#.png?${
                  new Date().getMilliseconds
                }`}
                identifier={(data) => data.id}
                setImagesToUpload={(images) => setImagesToUpload(images)}
                imagesToUpload={imagesToUpload}
                width="300px"
                data={imagens_produto}
              />
            )}
          </Grid>
        )}
      </Grid>
      <Box display="flex" justifyContent="flex-end">
        <Button color="primary" size="small" onClick={() => salvar()}>
          {<SaveIcon />}&nbsp;Gravar
        </Button>
        <Button
          color="secondary"
          size="small"
          onClick={() => {
            modals({ ...modals, editar: false });
          }}
        >
          {<CancelIcon />}&nbsp;Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default EditarProduto;
